export default class Product
{
	constructor()
	{
		if(jQuery(window).width() <= 768) {
			this.close();
		}

		jQuery( window ).resize(() => {
			if(jQuery(window).width() <= 768) {
				this.close();
			} else {
				this.open();
			}
		});

		jQuery('li.widget_product_categories > h2').on('click', function() {
			if(jQuery(window).width() <= 768) {
				jQuery('li.widget_product_categories > h2').toggleClass('active');
				jQuery(this).siblings().each(function() {
					jQuery(this).slideToggle();
				});
			}
		});

		jQuery('li.widget_text > h2').on('click', function() {
			if(jQuery(window).width() <= 768) {
				jQuery('li.widget_text > h2').toggleClass('active');
				jQuery('.widget_layered_nav').each(function () {
					jQuery(this).slideToggle();
				});
			}
		});
	}

	close() {
		jQuery('ul.product-categories').css('display', 'none');
		jQuery('.widget_layered_nav').css('display', 'none');
		jQuery('li.widget_product_categories > h2').removeClass('active');
		jQuery('li.widget_text > h2').removeClass('active');
	}

	open() {
		jQuery('ul.product-categories').css('display', '');
		jQuery('.widget_layered_nav').css('display', '');
		jQuery('li.widget_product_categories > h2').addClass('active');
		jQuery('li.widget_text > h2').addClass('active');
	}
}
